import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  ref: "borbistable",
  class: "grid-container"
}
const _hoisted_2 = { class: "left-grid" }
const _hoisted_3 = { style: {"display":"flex","flex-grow":"1","flex-direction":"column"} }
const _hoisted_4 = { id: "table-head" }
const _hoisted_5 = ["id"]
const _hoisted_6 = {
  key: 0,
  style: {"display":"flex"}
}
const _hoisted_7 = { class: "column-header" }
const _hoisted_8 = ["onMouseup"]
const _hoisted_9 = { class: "sort-display-container" }
const _hoisted_10 = {
  key: 2,
  class: "sort-position"
}
const _hoisted_11 = ["onMousedown"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["name"]
const _hoisted_14 = {
  key: 0,
  class: "table-row-footer"
}
const _hoisted_15 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_16 = { class: "loading-content" }
const _hoisted_17 = {
  key: 1,
  class: "empty-container"
}
const _hoisted_18 = { class: "empty-content" }
const _hoisted_19 = { class: "right-grid" }
const _hoisted_20 = {
  key: 0,
  class: "table-sidebar-toggle",
  style: {"height":"100%"}
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { style: {"overflow":"auto","flex-grow":"1","margin-bottom":"10px"} }
const _hoisted_23 = {
  key: 0,
  class: "side-pane-head"
}
const _hoisted_24 = { class: "side-pane-content" }
const _hoisted_25 = {
  key: 1,
  class: "footer-grid"
}
const _hoisted_26 = { class: "pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_b_spinner = _resolveComponent("b-spinner")!
  const _component_b_pagination = _resolveComponent("b-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", {
          id: "o-adv-table",
          class: _normalizeClass(['b-table', {'table-hover': _ctx.hasRowClick}]),
          style: _normalizeStyle({tableLayout: _ctx.isTableFixed() ? 'fixed' : ''})
        }, [
          _createElementVNode("thead", {
            class: "b-table-head",
            style: _normalizeStyle([_ctx.headClass])
          }, [
            _createElementVNode("tr", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnKeys, (key, index) => {
                return (_openBlock(), _createElementBlock("th", {
                  id: `th-${key}`,
                  key: index,
                  style: _normalizeStyle({width: _ctx.getColumnWidthByKey(key, _ctx.fitToPage)}),
                  scope: "col",
                  class: _normalizeClass([{ 'no-cursor': _ctx.getIgnoreSortByKey(key) }])
                }, [
                  _renderSlot(_ctx.$slots, `head(${key})`, {}, () => [
                    (key !== 'sidebar')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("span", {
                              class: "column-head-title",
                              onMouseup: () => _ctx.sortByTableColumn(key)
                            }, _toDisplayString(_ctx.getColumnDataByKey(key).label), 41, _hoisted_8),
                            (!!_ctx.getColumnDataByKey(key).headerBadge)
                              ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getColumnDataByKey(key).headerBadge), {
                                  key: 0,
                                  class: "header-badge"
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            (_ctx.sortDirection(key) === 'ascending')
                              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                  key: 0,
                                  icon: "fa-solid fa-arrow-up"
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.sortDirection(key) === 'descending')
                              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                  key: 1,
                                  icon: "fa-solid fa-arrow-down"
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.sortArray.length > 1 && _ctx.sortPosition(key) > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.sortPosition(key)), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: "table-column-slider",
                      onMousedown: ($event: any) => (_ctx.startDrag(key, $event))
                    }, null, 40, _hoisted_11)
                  ], true)
                ], 14, _hoisted_5))
              }), 128))
            ])
          ], 4),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedItems, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index,
                class: _normalizeClass({'striped': _ctx.striped && (_ctx.toggleRow || _ctx.singleSelect ? !_ctx.state.highlightedRows.includes(index) : true), 'highlightRow' : _ctx.state.highlightedRows.includes(index) }),
                style: _normalizeStyle({height: _ctx.rowHeight}),
                onClick: () => _ctx.onRowClick(item, index)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numberOfColumns, (num) => {
                  return (_openBlock(), _createElementBlock("td", {
                    class: "col-slot",
                    key: num,
                    name: `td(${_ctx.getColumnDataByIndex(num - 1).key})`
                  }, [
                    _renderSlot(_ctx.$slots, `cell(${_ctx.getColumnDataByIndex(num - 1).key})`, { item: item }, () => [
                      _createTextVNode(_toDisplayString(_ctx.getColumnDataForUI(num - 1, item as object)), 1)
                    ], true),
                    (_ctx.addTableFooter)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_13))
                }), 128))
              ], 14, _hoisted_12))
            }), 128))
          ])
        ], 6),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _renderSlot(_ctx.$slots, "loading", {}, () => [
                  _createVNode(_component_b_spinner)
                ], true)
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.loading && _ctx.showEmpty && _ctx.items.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _renderSlot(_ctx.$slots, "empty", {}, () => [
                  _cache[2] || (_cache[2] = _createElementVNode("span", null, "EMPTY STATE", -1))
                ], true)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      (_ctx.appConfigStore.getNewUIEnabled())
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("label", {
              class: _normalizeClass(['column-configurator', _ctx.hasSidePane ? 'column-container-left' : 'column-container-right']),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: "fa-solid fa-table-columns",
                style: {"font-size":"24px"}
              }),
              _cache[3] || (_cache[3] = _createTextVNode(" Columns "))
            ], 2),
            (_ctx.hasSidePane)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", {
                      style: _normalizeStyle(_ctx.state.showSidebar ? _ctx.sideBarOpenCss: _ctx.sideBarCloseCss),
                      class: _normalizeClass(['table-sidebar-toggle', 'sidebar-top-pad', _ctx.stickyHeader && _ctx.state.showSidebar ? 'sidebar-topoffset-pad' : ''])
                    }, [
                      _renderSlot(_ctx.$slots, "sidebar(sidebar)", {}, undefined, true)
                    ], 6)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(['table-sidebar-toggle', 'sidebar-top-pad', _ctx.stickyHeader && _ctx.state.showSidebar ? 'sidebar-topoffset-pad' : '']),
                  style: _normalizeStyle(_ctx.state.showSidebar ? _ctx.sideBarOpenCss: _ctx.sideBarCloseCss)
                }, [
                  _renderSlot(_ctx.$slots, "sidebar(sidebar)", {}, undefined, true)
                ], 6))
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.hasSidePane)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['side-pane-container','sidebar-top-pad']),
          style: _normalizeStyle({minWidth: _ctx.computedSidePaneOptions.width, borderLeft: '1px solid $gray-400', ..._ctx.tableClass})
        }, [
          _createElementVNode("div", _hoisted_22, [
            (!_ctx.computedSidePaneOptions.hideHeader)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("div", null, [
                    _renderSlot(_ctx.$slots, "side-pane-head", {}, () => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.computedSidePaneOptions.title), 1)
                    ], true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _renderSlot(_ctx.$slots, "side-pane", {}, undefined, true)
          ])
        ], 4))
      : _createCommentVNode("", true),
    (_ctx.showPagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_b_pagination, {
              modelValue: _ctx.currentPage,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentPage) = $event)),
              "total-rows": _ctx.filteredItems.length,
              "per-page": _ctx.perPage
            }, null, 8, ["modelValue", "total-rows", "per-page"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 512))
}